module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flag-a58b7f215a7b3b1fd06cd8548076d2d1.svg";